"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgGestureTwoFinger(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm8.0083 2.5a.9986.9986 0 1 1 1.99719 0v4.98566l.01288-.01819a1.05074 1.05074 0 0 1 .90643-.47376 1.06325 1.06325 0 0 1 1.08429 1.03229v.01691a1.0512 1.0512 0 0 1 .90662-.47394 1.06347 1.06347 0 0 1 1.08429 1.03223v.03387l-.00922 3.08623a3.17207 3.17207 0 0 1 -1.01814 2.3115 3.48333 3.48333 0 0 1 -2.43293.9672h-2.62846a3.94133 3.94133 0 0 1 -3.01325-1.3606l-2.63451-3.03283a.95139.95139 0 0 1 -.24109-.78687.998.998 0 0 1 .44769-.6886 1.08414 1.08414 0 0 1 1.34308.11481l1.06751 1a.12088.12088 0 0 0 .12762.03546v-6.28137a.99233.99233 0 0 1 1.98248-.07294v3.57294a.5.5 0 0 0 1 0z' })));
}
exports.default = SvgGestureTwoFinger;
